import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class DashboardService{
  
    private BASE_URL: string = environment.BACKEND_RACINE_URL+'dashboard';
  



    constructor(private http: HttpClient) { }
    
    
    
getDashboardSLAByWorkflowAndUsername(username,workflow) {
    let url: string = `${this.BASE_URL}/dashboard-sla-by-username?workflow=`+workflow+'&username='+username;
  
    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  
    return this.http.get<any>(url, { headers: reqHeader }).pipe(map(resp => {
      return resp;
    }));
}


    
syntheseNombreDossierEncoursFiltrerSurPeriode() {
  let url: string = `${this.BASE_URL}/dashboard-synthese-nombre-cree-filtrer-sur-periode`;

  var reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  return this.http.get<any>(url, { headers: reqHeader }).pipe(map(resp => {
    return resp;
  }));
}
  
  
 

    
syntheseMontantDemandeDossierEncoursFiltrerSurPeriode() {
  let url: string = `${this.BASE_URL}/dashboard-synthese-montant-demande-dossier-encours-filtrer-sur-periode`;

  var reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  return this.http.get<any>(url, { headers: reqHeader }).pipe(map(resp => {
    return resp;
  }));
}



syntheseMontantAccordeDossierEncoursFiltrerSurPeriode() {
  let url: string = `${this.BASE_URL}/dashboard-synthese-montant-accorde-dossier-encours-filtrer-sur-periode`;

  var reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  return this.http.get<any>(url, { headers: reqHeader }).pipe(map(resp => {
    return resp;
  }));
}
  

syntheseMontantMiseenplaceDossierEncoursFiltrerSurPeriode() {
  let url: string = `${this.BASE_URL}/dashboard-synthese-montant-miseenplace-dossier-encours-filtrer-sur-periode`;

  var reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  return this.http.get<any>(url, { headers: reqHeader }).pipe(map(resp => {
    return resp;
  }));
}
  
  
   
  
dashboardSlaAgent(debut,fin,filterDossier,filterIntervenant) {
  let url: string = `${this.BASE_URL}/dashboard-sla-agent?debut=`+debut+'&fin='+fin+'&filterDossier='+filterDossier+'&filterIntervenant='+filterIntervenant;

  var reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  return this.http.get<any>(url, { headers: reqHeader }).pipe(map(resp => {
    return resp;
  }));
}



dashboardSlaDirection(workflow) {
  let url: string = `${this.BASE_URL}/dashboard-sla-direction?workflow=`+workflow;

  var reqHeader = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  return this.http.get<any>(url, { headers: reqHeader }).pipe(map(resp => {
    return resp;
  }));
}

  


}      

    